import React from 'react';
import logo from '../../assets/images/logo.png';

export default function Logo(props) {
  return (
    <img src={logo} alt='' {...props} />
  );
}
